const getObjectPropertyLength = (obj: any) => {
  return Object.keys(obj).length;
};

export const toRows = <T = any>(flat: T[], columns: string[]): Record<string, T>[] => {
  const rows: Record<string, T>[] = [];
  const size = columns.length;

  for (let i = 0; i < flat.length; i += size) {
    const slice = flat.slice(i, i + size);
    const obj: Record<string, T> = {};
    columns.forEach((col, idx) => {
      obj[col] = (slice[idx] ?? null) as T;
    });
    rows.push(obj);
  }

  return rows;
};

export const flattenRows = <T = any>(rows: Record<string, T>[], columns: string[]): T[] => {
  return rows.flatMap(row => columns.map(col => row[col]));
};

export function printFormData(formData: FormData) {
  for (const [key, value] of formData.entries()) {
    console.log(`${key}:`, value);
  }
}

export const object = {
  getObjectPropertyLength,
  flattenRows,
  toRows,
  printFormData,
};
